export default "__VITE_ASSET__3b575277__"